import React from "react";
import PropTypes from "prop-types";
import store from "../../../../state/store";
import StructuralVariant from "../../../../models/StructuralVariant";
import ClinicalSampleCnv from "../../../../models/ClinicalSampleCnv";
import CnvCall from "../../tracks/cnvCalls/models/CnvCall";

function CnvLink({ item }) {
  const { varsomeHost } = store.getState();
  const { spec, link: path } = item;
  const link = `${varsomeHost}${path}`;

  if (path) {
    return (
      <a
        data-tooltip="Open in VarSome"
        data-tooltip-class="genome-browser-small-tooltip"
        className="tw-font-bold tw-leading-loose tw-tracking-wider tw-mr-1"
        href={link}
        target="_blank"
      >
        {spec || "Structural Variant"}
      </a>
    );
  }

  return (
    <div className="tw-font-bold tw-leading-loose tw-tracking-wider tw-mr-1">
      {spec || "Structural Variant"}
    </div>
  );
}

CnvLink.propTypes = {
  item: PropTypes.oneOfType([
    PropTypes.instanceOf(StructuralVariant),
    PropTypes.instanceOf(ClinicalSampleCnv),
    PropTypes.instanceOf(CnvCall),
  ]).isRequired,
};

CnvLink.defaultProps = {};

export default CnvLink;
